// extracted by mini-css-extract-plugin
module.exports = {"text":"text--h34TN","btn":"btn--a6h4f","action":"action--bIR0q"};